







































































import Vue from "vue";
import { BFormInput, BFormFile, BButton, BSpinner } from "bootstrap-vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import AppHeading from "@/components/AppHeading.vue";
import { TeamsActionTypes, TeamsState, namespaceTeams, TeamsMutationTypes, getInitialState } from "@/store/teams";
import Vuelidate from "vuelidate";
import { required } from "vuelidate/lib/validators";

Vue.use(Vuelidate);

@Component({
  name: "MyTeamsForm",
  components: {
    AppHeading,
    BFormInput,
    BFormFile,
    BButton,
    BSpinner
  },
  data() {
    return {
      isLoading: false,
      profilePictureSrc: ""
    };
  },

  computed: {
    name: {
      get() {
        return this.$store.state.teams.team.name;
      },
      set(value) {
        this.$store.commit(`${namespaceTeams}/${TeamsMutationTypes.UpdateTeamForm}`, { name: value });
      }
    },
    uniformColor: {
      get() {
        return this.$store.state.teams.team.uniform_color;
      },
      set(value) {
        this.$store.commit(`${namespaceTeams}/${TeamsMutationTypes.UpdateTeamForm}`, { uniform_color: value });
      }
    },
    uniformColorHex: {
      get() {
        return this.$store.state.teams.team.uniform_color_hex;
      },
      set(value) {
        this.$store.commit(`${namespaceTeams}/${TeamsMutationTypes.UpdateTeamForm}`, { uniform_color_hex: value });
      }
    },
    logo_path: {
      get() {
        return this.$store.state.teams.team.logo_path;
      },
      set(value) {
        this.$store.commit(`${namespaceTeams}/${TeamsMutationTypes.UpdateTeamForm}`, { logo_path: value });
      }
    },
    facebookProfile: {
      get() {
        return this.$store.state.teams.team.facebook_profile;
      },
      set(value) {
        this.$store.commit(`${namespaceTeams}/${TeamsMutationTypes.UpdateTeamForm}`, { facebook_profile: value });
      }
    }
  },
  validations: {
    name: {
      required
    },
    uniformColor: {
      required
    },
    uniformColorHex: {
      required
    },
    facebookProfile: {},
    logo_path: {}
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v[name]!;
      return $dirty ? !$error : null;
    }
  }
})
export default class TeamForm extends Vue {
  @Prop() title!: String;
  @Prop({ required: true }) viewType!: "new" | "edit";
  @Prop({ required: true }) submitHandler!: () => Promise<any>;

  isLoading!: boolean;
  profilePictureSrc!: string | File;

  @Watch("logo_path", { immediate: true })
  onLogoPathChanged(newLogoPath: string | File) {
    if (newLogoPath instanceof File) {
      this.profilePictureSrc = URL.createObjectURL(newLogoPath);
    } else {
      this.profilePictureSrc = newLogoPath;
    }
  }

  async onSubmit(event: Event) {
    this.isLoading = true;
    event.preventDefault();
    await this.submitHandler();
    this.isLoading = false;
  }

  beforeDestroy() {
    if (this.viewType === "edit") {
      this.$store.commit(`${namespaceTeams}/${TeamsMutationTypes.SetTeam}`, getInitialState().team);
    }
  }
}
